export default __webpack_public_path__ + "static/media/cuttingEdge.23f1e1d1.md";